'use client'

import { useEffect } from 'react'

const PLAUSIBLE_DOMAIN = 'isu.do'

export default function PlausibleAnalytics() {
    useEffect(() => {
        void import('@plausible-analytics/tracker').then(({ init }) => {
            init({ domain: PLAUSIBLE_DOMAIN })
        })
    }, [])

    return null
}
